/* Morpheus GA4 layer — G-DMMCXDJ0HH. CTA events only.
   Shopify's Google & YouTube channel owns config + page_view + ecommerce
   (view_item/add_to_cart/purchase). This file only adds the custom CTA layer,
   so nothing is ever double-counted regardless of script load order. */
(function () {
  'use strict';
  if (window.__mphGA4) return;
  window.__mphGA4 = true;

  var GA_ID = 'G-DMMCXDJ0HH';
  var DEBUG = /preview_theme_id=/.test(location.search);
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };

  function send(name, params) {
    try { params = params || {}; if (DEBUG) params.debug_mode = true; window.gtag('event', name, params); }
    catch (e) {}
  }

  // CTA click layer — the theme's only job.
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-mph-event]') : null;
    if (!el) return;
    send(el.getAttribute('data-mph-event'), {
      mph_source: el.getAttribute('data-mph-source') || '',
      link_url: el.href || '',
      link_text: (el.textContent || '').trim().slice(0, 80),
      transport_type: 'beacon'
    });
  }, true);

  // Safety net: only if the Google channel never registers a GA4 config (e.g. channel
  // removed) do we add one — with page_view OFF — so CTA events still route, never duplicating.
  var tries = 0;
  (function ensureConfig() {
    for (var i = 0; i < window.dataLayer.length; i++) {
      var d = window.dataLayer[i];
      if (d && typeof d.length === 'number' && d[0] === 'config' && d[1] === GA_ID) return;
    }
    if (tries++ < 60) return setTimeout(ensureConfig, 50);
    var s = document.createElement('script'); s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA_ID; document.head.appendChild(s);
    window.gtag('js', new Date());
    var cfg = { send_page_view: false }; if (DEBUG) cfg.debug_mode = true;
    window.gtag('config', GA_ID, cfg);
  })();
})();